import { Flex, Icon, Tooltip, TooltipContent, TooltipTrigger, Typography, TypographyProps, useToast } from '@alpine-iq/ui-library';
import React from 'react';

export type CopyableTextPropsAsChildren = TypographyProps & {
	children: string;
	copyText?: string;
	tooltip?: string;
};

export type CopyableTextPropsAsCopyText = TypographyProps & {
	copyText: string;
	children?: React.ReactNode;
	tooltip?: string;
};

export type CopyableTextProps = CopyableTextPropsAsChildren | CopyableTextPropsAsCopyText;

export default function CopyableText({ children, copyText, tooltip, ...props }: CopyableTextProps) {
	const tidRef = React.useRef<NodeJS.Timeout>();
	const { addToast } = useToast();
	const [copied, setCopied] = React.useState(false);

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Flex
					css={{ cursor: 'pointer' }}
					align="center"
					onClick={(e) => {
						const textToCopy = copyText || children;
						navigator.clipboard.writeText(textToCopy?.toString() ?? '');
						setCopied(true);
						if (tidRef.current) clearTimeout(tidRef.current);
						tidRef.current = setTimeout(() => setCopied(false), 2000);
						addToast({ message: 'Copied to clipboard', type: 'success', placement: 'top' });
						props.onClick?.(e);
					}}
				>
					<Typography {...props}>{children}</Typography>
					<Icon
						height={16}
						width={16}
						css={{ opacity: copied ? 1 : 0.85 }}
						type={copied ? 'CHECK_MARK' : 'COPY'}
						color={copied ? 'var(--success)' : 'var(--brand-primary)'}
					/>
				</Flex>
			</TooltipTrigger>
			<TooltipContent
				style={{
					zIndex: 999999,
				}}
			>
				{tooltip || copyText || children}
			</TooltipContent>
		</Tooltip>
	);
}
